import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { DataProvider } from "./data/DataContext";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminPanel from "./pages/admin/AdminPanel";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import GameDetail from "./pages/GameDetail";
import StaticPage from "./pages/StaticPage";
import YonoAllGames from "./pages/YonoAllGames";

function App() {
  return (
    <HelmetProvider>
    <DataProvider>
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
    </DataProvider>
    </HelmetProvider>
  );
}

const Shell = () => {
  const isAdmin = useLocation().pathname.startsWith("/admin");
  return (
      <div className="min-h-screen bg-[#013013] text-white flex flex-col overflow-x-hidden">
        {!isAdmin && <Navbar />}
        <main className={`flex-1 ${isAdmin ? "" : "pt-16"}`}>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<AdminPanel />} />
            <Route path="/" element={<Home />} />
            <Route path="/game/:slug" element={<GameDetail />} />
            <Route path="/yono-all-games" element={<YonoAllGames />} />
            <Route path="/about" element={<StaticPage page="about" />} />
            <Route path="/contact" element={<StaticPage page="contact" />} />
            <Route path="/disclaimer" element={<StaticPage page="disclaimer" />} />
            <Route path="/privacy" element={<StaticPage page="privacy" />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        {!isAdmin && <Footer />}
        <Toaster position="top-center" richColors />
      </div>
  );
};

export default App;
